export const CHECK_IN_OUT_LOCK_TTL_SECONDS = 5;
export const IDEMPOTENCY_BASE_PREFIX = "idem:v2:";
export const IDEMPOTENCY_TTL_SECONDS = 86400;
export const IDEMPOTENCY_PROCESSING_TTL_SECONDS = 120;
export const DEFAULT_EXECUTE_DEDUPE_TTL_SECONDS = 1 * 60 * 60; // 1 hour
export const DEFAULT_DISPATCH_DEDUPE_TTL_SECONDS = 10 * 60; // 10 minutes